export default __webpack_public_path__ + "static/media/checking-completed-task.ff1a9a3b.gif";